import { render } from "./ScrollTop.vue?vue&type=template&id=18959e7c&scoped=true&ts=true"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"

import "./ScrollTop.vue?vue&type=style&index=0&id=18959e7c&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18959e7c"]])

export default __exports__